import gsap from 'gsap';
import React, { createRef, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { useDidMount } from './useDidMount';
const Content = styled.div `
  max-height: var(--toggle-height-value, auto);
  transition:
    max-height 0.2s,
    padding 0.2s;
  padding: var(--toggle-height-padding, 0);

  ${({ $isClose }) => $isClose &&
    css `
      padding: 0;
      max-height: 0;
      pointer-events: none;
      overflow: hidden;
      transition:
        max-height 0.2s,
        padding 0.2s,
        overflow 0s linear 0.2s;
    `}
`;
const Inner = styled.div `
  --toggle-height-mask-position: 100%;
  transition: opacity 0.3s;

  ${({ $isClose }) => !$isClose &&
    css `
      --toggle-height-mask-position: 0%;
    `}

  ${({ $isClose }) => $isClose &&
    css `
      opacity: 0;
      transition-duration: 0.15s;
    `}

  ${({ $isClose, $hasOverflow }) => ($isClose || $hasOverflow) &&
    css `
      mask-position: 0% var(--toggle-height-mask-position);
      mask-size: 100% 400%;
      mask-image: linear-gradient(black 0%, black 25%, transparent 75%, transparent 100%);
      mask-repeat: no-repeat;
    `}
`;
export const ToggleHeight = (props) => {
    const [hasOverflowState, setHasOverflowState] = useState(props.isClose ?? false);
    const [isClose, setIsClose] = useState(props.isClose ?? false);
    const didMount = useDidMount();
    const wrapperRef = createRef();
    const innerRef = createRef();
    const styleProps = {
        $isClose: isClose,
        $hasOverflow: props.hasOverflow ?? hasOverflowState,
    };
    useEffect(() => {
        const state = props.isClose ?? false;
        const wrapper = wrapperRef.current;
        if (props.onChange) {
            props.onChange(state);
        }
        if (didMount) {
            gsap.set(wrapper, {
                '--toggle-height-value': `${innerRef.current?.offsetHeight}px`,
            });
            if (!state) {
                setTimeout(() => gsap.set(wrapper, {
                    '--toggle-height-value': 'auto',
                }), 200);
            }
            gsap.fromTo(innerRef.current, {
                '--toggle-height-mask-position': state ? '0%' : '120%',
            }, {
                '--toggle-height-mask-position': state ? '120%' : '0%',
                duration: state ? 0.15 : 0.35,
                clearProps: true,
                onStart: () => {
                    setIsClose(state);
                    setHasOverflowState(true);
                },
                onComplete: () => {
                    setHasOverflowState(false);
                    if (props.onChangeComplete) {
                        props.onChangeComplete(state);
                    }
                },
            });
        }
    }, [props.isClose]);
    return (React.createElement(Content, { ref: wrapperRef, className: props.className, ...styleProps },
        React.createElement(Inner, { ref: innerRef, ...styleProps }, props.children)));
};
//# sourceMappingURL=ToggleHeight.js.map